import React from 'react';

import classNames from 'classnames';

import A from 'wanderu-component-react-router-link';
import { Section } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import {
    LINK_SECTION,
} from '../../constants';

import styles from './LinkTable.scss';

function LinkTable(props) {
    const {
        t,
        limitLinkFlow,
    } = props;

    return (
        <Section
            className={classNames(
                styles.pageSection,
                { [styles.smallPageSection]: limitLinkFlow },
            )}
        >
            <nav
                className={classNames(
                    styles.container,
                    { [styles.smallContainer]: limitLinkFlow },
                )}
            >
                {LINK_SECTION.map(({ sectionTitle, sectionLinks, seoHidden: hideSection }) => {
                    if (limitLinkFlow && hideSection) {
                        return null;
                    }

                    return (
                        <div
                            className={styles.linkSection}
                            key={sectionTitle}
                        >
                            <p className={styles.title}>
                                {t(sectionTitle)}
                            </p>
                            <ul
                                className={styles.linkList}
                            >
                                {sectionLinks.map(({
                                    title, url, native, seoHidden: hideLink,
                                }) => {
                                    if (limitLinkFlow && hideLink) {
                                        return null;
                                    }

                                    return (
                                        <li
                                            className={styles.linkContainer}
                                            key={url}
                                        >
                                            <A
                                                className={styles.link}
                                                href={url}
                                                native={!!native}
                                            >
                                                {t(title)}
                                            </A>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </nav>
        </Section>
    );
}

export { LinkTable };
export default localize(LinkTable, 'baseApp');
